import { Component, OnDestroy, OnInit } from '@angular/core';
import { ObservableMedia } from '@angular/flex-layout';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { AuthService } from '../../services/auth.service';
import { UserProfileComponent } from '../user-profile/user-profile.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;

	public sideNavMode: string;
	public sideNavIsOpened: boolean;
	public navIconIsShowed: boolean;

  constructor(public authService: AuthService,
							private media: ObservableMedia,
							private dialog: MdDialog,
							private router: Router) {
		this.subscriptionManager = new Subscription();

		this.subscriptionManager.add(media.subscribe(next => {
      this.setupSideNav();
    }));

		this.setupSideNav();
	}

  ngOnInit() { }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public toggleSideNav(): void {
		this.sideNavIsOpened = !this.sideNavIsOpened;
	}

	public setupSideNav(): void {
		if (this.media.isActive('gt-xs'))
		{
			this.sideNavIsOpened = true;
			this.sideNavMode = "side";
			this.navIconIsShowed = false;
		}
		else
		{
			this.sideNavIsOpened = false;
			this.sideNavMode = "over";
			this.navIconIsShowed = true;
		}
	}

	public logOut(): void {
		this.authService.logOut();
		this.router.navigate(['add-application']);
	}

	public openUserProfile(): void {
		let dialogRef = this.dialog.open(UserProfileComponent, {
			width: '300px'
		});
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/navigation/navigation.component.ts